import { apiClient } from "./apiClient"; // adjust the import path as needed
import { SEARCH_CARS_URL } from "./endpoints";

type CarSearchParams = {
  city: string;
  minPrice: string;
  maxPrice: string;
  slug: string;
};

export const carSearchService = {
  searchCars: async (params: CarSearchParams) => {

    return apiClient.get(`${SEARCH_CARS_URL}`, params, {
      withAuth: false,
    });
  },
};
